import Plyr from "plyr"
import Vimeo from "@vimeo/player"
import YouTubePlayer from "youtube-player"

export let activeVimeo = null
export let activeYoutube = null
export let activePlyr = null

export default {
	init: (el) => {
		const wrapper = el.querySelector(".js-plyr-wrapper")
		const frame = el.querySelector("iframe")
		const youtubeWrapper = el.querySelector("#youtube-wrapper")
		const playButton = el.querySelector(".js-play-button")
		const cover = el.querySelector(".js-video-cover")
		const { pauseOnSlideChange } = el.dataset

		const setPlayerDimensions = (height, width) => {
			const elWidth = el.getBoundingClientRect().width

			const maxHeight = (elWidth * height) / width
			el.style.height = `${Math.floor(maxHeight)}px`
			el.style.maxWidth = `${elWidth}px`
		}

		if (frame && frame.src.includes("vimeo")) {
			el.classList.add("video-player-vimeo")

			const vimeoPlayer = new Vimeo(frame, {
				controls: false,
				playsinline: "false",
				color: "#00ff00",
			})

			Promise.all([
				vimeoPlayer.getVideoWidth(),
				vimeoPlayer.getVideoHeight(),
			]).then(function (dimensions) {
				const width = dimensions[0]
				const height = dimensions[1]

				setPlayerDimensions(height, width)

				window.addEventListener("resize", () => {
					setPlayerDimensions(height, width)
				})
			})

			playButton.style.setProperty("display", "block")
			playButton.addEventListener("click", () => {
				vimeoPlayer.controls = "true"
				vimeoPlayer.play().then((player) => {
					cover?.style.setProperty("display", "none")
					playButton.style.setProperty("display", "none")

					if (pauseOnSlideChange) {
						activeVimeo = vimeoPlayer
					}
				})
			})
		}

		if (!frame && youtubeWrapper) {
			const coverImg = cover.querySelector("img")
			const youtubePlayer = YouTubePlayer("youtube-wrapper", {
				width: 1280,
				height: 720,
			})
			const getYoutubeId = (url) => {
				const regExp = /.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=)([^#\&\?]*).*/
				const match = url.match(regExp)
				return match && match[1].length == 11 ? match[1] : false
			}
			const id = getYoutubeId(youtubeWrapper.dataset.videoSrc)
			const imgUrl = `https://i3.ytimg.com/vi/${id}/maxresdefault.jpg`

			el.classList.add("video-player-youtube")
			youtubePlayer.loadVideoById(id)

			if (coverImg.attributes.src.value === "") {
				coverImg.src = imgUrl
			}

			setPlayerDimensions(760, 1280)
			window.addEventListener("resize", () => {
				setPlayerDimensions(760, 1280)
			})

			playButton.style.setProperty("display", "block")
			playButton.addEventListener("click", () => {
				cover?.style.setProperty("display", "none")
				playButton.style.setProperty("display", "none")
				youtubePlayer.playVideo()

				if (pauseOnSlideChange) {
					activeYoutube = youtubePlayer
				}
			})
		}

		if (frame && !frame.src.includes("vimeo")) {
			if (el.dataset.player && el.dataset.player === "recipe") {
				const recipePlayer = new Plyr(el, {
					muted: true,
					autoplay: true,
					loop: { active: true },
				})
			} else {
				const player = new Plyr(wrapper, {
					controls: [
						"play",
						"progress",
						"current-time",
						"mute",
						"volume",
						"captions",
						"settings",
						"pip",
						"airplay",
						"fullscreen",
					],
				})

				playButton.addEventListener("click", () => {
					cover?.style.setProperty("display", "none")
					playButton.style.setProperty("display", "none")
					player.play()
					if (pauseOnSlideChange) {
						activePlyr = player
					}
				})

				player.on("ended", () => {
					cover.style.removeProperty("display")
					player.restart()
				})
			}
		}
	},
}
